Button = require 'components/common/button'
Translation = require 'components/mixins/translation'

EmptyCommentButton = createReactClass
  displayName: 'EmptyCommentButton'

  mixins: [Translation()]

  propTypes:
    title: PropTypes.string

  render: ->
    title = @props.title ? @i18n 'actions.comment'
    classes = classNames "comment comment-blank", @props.className
    <Button className={classes} title={title} onClick={@props.onClick}/>

module.exports = EmptyCommentButton
